import { Box, Skeleton } from '@mui/material';

export const TableLoadingIndicator = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Skeleton animation="wave" height={35} width="100%" />
      <Skeleton animation="wave" height={35} width="75%" />
      <Skeleton animation="wave" height={35} width="50%" />
    </Box>
  );
};
